import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
};
const getters = {
};

const actions = {
    [actionType.SEARCH_LISTING_FOR_CLASSIFIEDS]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.get(`/admin/listings`,{params}).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
    [actionType.CHANGE_LISTING_CATEGORY]: async function ({commit}, params){
        return new Promise((resolve,reject) => {
            api.put(`/admin/listings/${params.listingId}/category/${params.categoryId}`,{}).then(result => {
                resolve(result);
            })
            .catch(error => reject(error));
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}